export const SET_CURRENT_GXT = 'SET_CURRENT_GXT'
export const SET_GXT_LOADING = 'SET_GXT_LOADING'
